export default __webpack_public_path__ + "static/media/nftcollectionSVG.7be97e92.svg";